
<ap-tiny-editor [editorValue]="editorValue"
            [height]="height"
            [hideToolbar]="hideToolbar"
            [hideStatusBar]="hideStatusBar"
            [disabled]="disabled"
            [editorName]="editorName"
            [autoResize]="autoResize"
            [autoResizeMaxHeight]="autoResizeMaxHeight"
            [autoResizeMaxHeight]="autoResizeMinHeight"
            [setFocusOnInit]="setFocusOnInit"
            [setFocusOnInitCursorAtEnd]="setFocusOnInitCursorAtEnd"
            [required]="required"
            [displayName]="displayName"
            [form]="form"
            (editorValueChanged)="onEditorValueChanged($event)"
            (dirtyChanged)="onDirtyChanged()"
            #apTinyEditor>
</ap-tiny-editor>
